import { CustomThemeToken } from '@/theme';
import { Breakpoint, Row } from 'antd';
import styled from 'styled-components';

export const CardsContainer = styled.div`
  width: 100%;
  overflow: hidden;
  padding: 0;

  .card-column {
    width: calc(100% - 1rem);
    margin: 0 ${({ theme: { token } }) => token.marginXS}px;

    @media (min-width: 576px) {
      width: 17.625rem;
    }
  }
`;

export const CardsRow = styled(Row)`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0;
  width: calc(100% + 1rem);
`;

export const FlowGroupContainer = styled.div<{
  $screens: Partial<Record<Breakpoint, boolean>>;
  $isMobile: boolean;
  theme: { token: CustomThemeToken };
}>`
  margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
  width: 100%;

  container-type: inline-size;

  .flow-grid-container {
    display: flex;
    flex-wrap: nowrap;
    width: content-fit;
    padding: ${({ theme: { token } }) => token.paddingXS}px;
    justify-content: ${({ $isMobile }) => ($isMobile ? 'flex-start' : 'flex-end')};
    align-items: stretch;
    overflow-x: hidden;

    padding-left: 30px;
    gap: ${({ $isMobile, theme: { token } }) => ($isMobile ? `${token.paddingXS}` : `${token.paddingSM}`)};

    @media (max-width: 991px) {
      flex-wrap: nowrap;
      gap: 6px;
      justify-content: center;
      overflow-x: hidden;
      padding: ${({ theme: { token } }) => token.paddingXXS}px;
      align-items: stretch;
    }

    @media (max-width: 768px) {
      flex-wrap: nowrap;
      gap: ${({ theme: { token } }) => `${token.paddingXXS}`};
      justify-content: center;
      overflow-x: hidden;
      padding: 2px;
      align-items: stretch;
    }

    @media (max-width: 480px) {
      flex-wrap: nowrap;
      gap: 2px;
      justify-content: flex-start;
      overflow-x: hidden;
      padding: 1px;
      align-items: stretch;
    }
  }

  .mini-grid {
    padding: 0;
    margin: 0;
  }

  @container (max-width: 400px) {
    .custom-style {
      width: 80%;
    }
    .mini-grid {
      width: 800%;
    }
  }
  @container (min-width: 401px) and (max-width: 600px) {
    .custom-style {
      width: 100%;
    }

    .mini-grid {
      width: 100%;
    }
  }

  @container (min-width: 601px) {
    .custom-style {
      width: 70%;
    }

    .mini-grid {
      width: 70%;
    }
  }

  .mini-col {
    display: flex;
    width: fit-content;
    flex: 0 0 auto;
    max-width: none;
    padding: ${({ $isMobile, theme: { token } }) => ($isMobile ? `${token.paddingXXS}` : `${token.paddingXS}px`)};
    flex-direction: column;
    gap: ${({ $isMobile, theme: { token } }) => ($isMobile ? `${token.paddingXXS}px` : `${token.paddingXXS}px`)};
    min-width: 0;
    justify-content: space-between;
    min-height: 40px;

    @media (max-width: 991px) {
      padding: ${({ theme: { token } }) => token.paddingXXS}px;
      gap: ${({ theme: { token } }) => token.paddingXXS}px;
      flex-shrink: 0;
      min-height: 35px;
    }

    @media (max-width: 768px) {
      padding: 2px;
      gap: 2px;
      flex-shrink: 0;
      min-height: 30px;
    }

    @media (max-width: 480px) {
      padding: 3px;
      gap: 1px;
      width: content-fit;
      flex-shrink: 0;
      min-height: 25px;
    }
  }

  .mini-col-status {
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => `${token.paddingXXS}px`};
    justify-content: space-between;
    min-height: 40px;

    @media (max-width: 991px) {
      gap: 3px;
      min-height: 35px;
    }

    @media (max-width: 768px) {
      gap: 2px;
      min-height: 30px;
    }

    @media (max-width: 480px) {
      gap: 1px;
      min-height: 25px;
    }
  }

  .mini-col-margin {
    margin-top: 2px;

    @media (max-width: 991px) {
      margin-top: 0px;
    }

    @media (max-width: 768px) {
      margin-top: 0px;
    }

    @media (max-width: 480px) {
      margin-top: 0px;
    }
  }
  .mini-col-more-margin {
    margin-top: 3px;

    @media (max-width: 991px) {
      margin-top: 0px;
    }

    @media (max-width: 768px) {
      margin-top: 0px;
    }

    @media (max-width: 480px) {
      margin-top: 0px;
    }
  }

  .mini-cell {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-size: ${({ theme: { token } }) => token.fontSizeSM};
    padding: ${({ $isMobile }) => ($isMobile ? '2px 4px' : '4px 6px')};
    background-color: transparent;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 20px;

    @media (max-width: 991px) {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      padding: 2px 3px;
      min-height: 18px;
    }

    @media (max-width: 768px) {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      padding: 1px 2px;
      min-height: ${({ theme: { token } }) => token.padding}px;
    }

    @media (max-width: 480px) {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      padding: 1px;
      min-height: 14px;
    }
  }

  .mini-cell-status {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    padding: ${({ $isMobile }) => ($isMobile ? '2px 4px' : '4px 6px')};
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 20px;

    @media (max-width: 991px) {
      padding: 2px 3px;
      min-height: 18px;
    }

    @media (max-width: 768px) {
      padding: 1px 2px;
      min-height: ${({ theme: { token } }) => token.padding}px;
    }

    @media (max-width: 480px) {
      padding: 1px;
      min-height: 14px;
    }
  }

  .flow-specific-value {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    line-height: ${({ theme: { token } }) => token.lineHeightLG};
    color: ${({ theme: { token } }) => token.colorText};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;

    @media (max-width: 991px) {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      gap: 1px;
    }

    @media (max-width: 768px) {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      gap: 1px;
    }

    @media (max-width: 480px) {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      gap: 0px;
    }
  }

  .flow-specific-value-differences-color {
    color: ${({ theme: { token } }) => token.colorSuccessText};
  }
  .flow-specific-value-differences {
    margin-top: ${({ $isMobile }) => ($isMobile ? '2px' : '0px')};
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: ${({ theme: { token } }) => token.paddingMD}px;

    @media (max-width: 991px) {
      margin-top: 0px;
      min-height: 18px;
    }

    @media (max-width: 768px) {
      margin-top: 0px;
      min-height: ${({ theme: { token } }) => token.padding}px;
    }

    @media (max-width: 480px) {
      margin-top: 0px;
      min-height: 14px;
    }
  }

  .flow-specific-type {
    margin-left: ${({ theme: { token } }) => token.paddingXXS}px;
    white-space: nowrap;
    margin-top: 2px;
    display: inline-flex;
    align-items: center;

    @media (max-width: 991px) {
      margin-left: 1px;
    }

    @media (max-width: 768px) {
      margin-left: 1px;
    }

    @media (max-width: 480px) {
      margin-left: 0px;
    }
  }

  .bordered-container {
    display: block;
    width: 100%;
    padding: ${({ theme: { token } }) => token.padding}px;
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
    border: 0.0625rem solid ${({ theme: { token } }) => token.colorBorder};
    box-sizing: border-box;

    .flow-section-skeleton {
      margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
    }

    @media (min-width: 576px) {
      display: inline-block;
      width: auto;
      padding: ${({ theme: { token } }) => token.padding}px;
    }

    .flow-header-content {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin-bottom: ${({ theme: { token } }) => token.margin}px;
      max-width: calc(100% - 2rem);

      @media (min-width: 48rem) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
    }

    .flow-title-container {
      display: flex;
      flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
      justify-content: ${({ $isMobile }) => ($isMobile ? 'flex-start' : 'space-between')};
      align-items: ${({ $isMobile }) => ($isMobile ? 'flex-start' : 'center')};
      gap: ${({ $isMobile, theme: { token } }) => ($isMobile ? '0' : `${token.onePxSize}rem`)};
      width: 100%;
      min-width: 0;
    }

    .flow-icon-wrapper {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      gap: ${({ theme: { token } }) => token.paddingSM}px;
    }

    .flow-content-wrapper {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      min-width: 0;
      max-width: 100%;

      &.passed {
        flex-direction: row;
        align-items: center;
        gap: 1rem;
      }

      @media (min-width: 400px) {
        flex-direction: row;
        align-items: center;
        gap: ${({ theme: { token } }) => `${token.onePxSize}rem`};
      }
    }
    .flow-title {
      color: ${({ theme: { token } }) => token.colorText};
      font-family: ${({ theme: { token } }) => token.fontFamily};
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      font-style: normal;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      line-height: ${({ theme: { token } }) => token.lineHeight};
      margin-bottom: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 7rem;
      min-width: 5rem;
      @media (min-width: 576px) {
        max-width: 12.5rem;
      }
    }
    .flow-sum-container {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      white-space: nowrap;
      flex-wrap: nowrap;
      overflow: hidden;

      @media (max-width: 991px) {
        gap: 0.5rem;
        flex-wrap: wrap;
        justify-content: flex-start;
      }

      @media (max-width: 768px) {
        gap: 0.25rem;
        flex-wrap: wrap;
      }

      @media (max-width: 400px) {
        gap: 0.125rem;
        flex-wrap: wrap;
      }
    }
    .flow-sum-text {
      flex-shrink: 0;
      color: ${({ theme: { token } }) => token.colorTextSecondary};
      font-family: ${({ theme: { token } }) => token.fontFamily};
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      font-style: normal;
      font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
      line-height: ${({ theme: { token } }) => token.lineHeight};
      margin-bottom: 0;
      white-space: nowrap;
      display: flex;
      align-items: center;
      gap: ${({ theme: { token } }) => token.onePxSize}px;

      @media (max-width: 991px) {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        gap: 2px;
      }

      @media (max-width: 768px) {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        gap: 1px;
      }

      @media (max-width: 400px) {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        gap: 1px;
      }
    }
    .flow-sum-value {
      font-family: ${({ theme: { token } }) => token.fontFamily};
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      font-style: normal;
      padding-right: 2px;
      margin-left: ${({ $isMobile, theme: { token } }) => ($isMobile ? `2px` : `${token.paddingXS}px`)};

      line-height: ${({ theme: { token } }) => token.lineHeightSM};
      white-space: nowrap;
      flex-shrink: 0;

      @media (max-width: 991px) {
        font-size: ${({ theme: { token } }) => token.fontSizeMG}px;
      }

      @media (max-width: 768px) {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      }

      @media (max-width: 400px) {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      }

      &.success {
        color: ${({ theme: { token } }) => token.colorSuccess};
      }
      &.error {
        color: ${({ theme: { token } }) => token.colorError};
      }
      &.testing,
      &.not-included {
        color: ${({ theme: { token } }) => token.colorTextTertiary};
      }
    }
    .flow-comment-button-container {
      display: flex;
      flex-direction: ${({ $isMobile }) => ($isMobile ? `column ` : `row`)};
      align-items: ${({ $isMobile }) => ($isMobile ? `flex-start` : `center`)};
      justify-content: ${({ $isMobile }) => ($isMobile ? `flex-start` : `flex-start`)};
    }

    .flow-comment-button {
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
      padding: 0 ${({ theme: { token } }) => token.paddingXS}px;
      margin-left: 1px;
      height: 1.5rem;
      border-radius: ${({ theme: { token } }) => token.borderRadiusSM}px;
      cursor: pointer;

      &:hover {
        background: ${({ theme: { token } }) => token.colorFillSecondary};
      }
    }
    .flow-comment-button-text {
      color: ${({ theme: { token } }) => token.colorPrimary};
      font-family: ${({ theme: { token } }) => token.fontFamily};
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      font-weight: normal;
      line-height: 1.25rem;
      white-space: nowrap;
    }
  }
`;
